import loadable from '@loadable/component';

export const OrgDashboardPostAListingPageLoadable = loadable(
  () => import('./OrgDashboardPostAListingPage'),
  {
    resolveComponent: (module) => module.OrgDashboardPostAListingPage,
  },
);
